import { Voter } from "@activecollab/security";
import { isFinancialManager, isMember, isOwner, isPowerUser } from "~/utils/userHelper";

export class WorkloadVoter extends Voter {
  attributes = ["drop_a_task"];

  supports(attribute, subject) {
    if (!this.attributes.includes(attribute)) {
      return false;
    }

    return subject && (subject.type === "Subtask" || subject.type === "Task" || subject.type === "CalendarEvent");
  }
  voteOnAttribute(attribute, subject, user) {
    const { projectIds = [], project_id, type } = subject;
    switch (attribute) {
      case "drop_a_task": {
        if (type === "CalendarEvent") {
          return false;
        }
        if (typeof project_id === "undefined") {
          return false;
        }
        if (isOwner(user)) {
          return true;
        }
        if (isMember(user) && (isPowerUser(user) || isFinancialManager(user))) {
          if (projectIds.includes(project_id)) {
            return true;
          }
        }
        return false;
      }
    }
  }
}
